import React from "react";
import { Card, Text } from "@jsq/ds/core";
import * as styles from "../styles_vanilla.css";
import DocumentDetailsRow from "./DocumentDetailsRow";

export type NormalizedDocument = {
  id: string;
  documentVersion?: {
    name?: string | null;
    downloadUrl?: string | null;
  } | null;
};

type DocumentDetailsCardProps = {
  cardTitle: string;
  documentList?: NormalizedDocument[];
};

const DocumentDetailsCard = ({ cardTitle, documentList }: DocumentDetailsCardProps) => {
  const handleGoToDownloadPage = (documentUrl: string) => {
    window.open(documentUrl);
  };

  const hasDocuments = Boolean(documentList?.length);

  return (
    <Card data-testid="documents-card" title={cardTitle}>
      {hasDocuments && (
        <>
          {documentList?.map((document) => {
            return (
              <Card
                data-testid="individual-document-card"
                className={styles.documentDetailsCard}
                key={document.id}
                role="button"
                onClick={() =>
                  handleGoToDownloadPage(document.documentVersion?.downloadUrl ?? "")
                }
              >
                <DocumentDetailsRow
                  documentName={document.documentVersion?.name ?? undefined}
                />
              </Card>
            );
          })}{" "}
        </>
      )}
      {!hasDocuments && (
        <Text data-testid="empty-state-text" variant="secondary-md">
          No documents uploaded
        </Text>
      )}
    </Card>
  );
};

export default DocumentDetailsCard;
